import { AppProps } from "next/app";
import Head from "next/head";
import dynamic from "next/dynamic";
import path from "path";
import "pwa-mmt-ui-header/ssr/header.css";
import { ComponentType, useEffect } from "react";
import { loadGTM } from "@tm/utility";

// Magic import, https://github.com/nrwl/nx/issues/9017#issuecomment-1140066503
path.resolve("./next.config.js");
const MMTLogin = dynamic(
  () => import("@tm/auth").then((module) => module.MMTLogin),
  { ssr: false }
);

const GdprConsentForm: ComponentType<{ isPWA: boolean }> = dynamic(
  () => import("MMT-UI/GdprConsentForm"),
  {
    ssr: false,
  }
);

function CustomApp({ Component, pageProps }: AppProps) {
  const { isDesktop } = pageProps;

  useEffect(() => {
    loadGTM();
  }, []);

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <link
          rel="preload"
          href="https://fonts.gstatic.com/s/raleway/v28/1Ptug8zYS_SKggPNyC0IT4ttDfA.woff2"
          as="font"
          crossOrigin=""
        />
        <link
          rel="preload"
          href="https://fonts.gstatic.com/s/opensans/v34/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-mu0SC55I.woff2"
          as="font"
          crossOrigin=""
        />
        <title>Forex Cards and Currency at Best rates</title>
      </Head>
      <main className="app">
        <MMTLogin />
        <Component {...pageProps} />
        <GdprConsentForm isPWA={!isDesktop} />
      </main>
    </>
  );
}

export default CustomApp;
